<template>
  <modal v-if="isShow" class="search-friend-modal">
    <template slot="header">
      <h4 class="modal-title">임원진 설정</h4>
      <md-button class="md-simple md-just-icon md-round modal-default-button">
        <md-icon>clear</md-icon>
      </md-button>
    </template>
    <template slot="body">
      <div class="md-layout">
        <table class="flex-table">
          <tr>
            <th>교우번호</th>
            <td><input type="text" v-model="memberInfo.memberNo" disabled></td>
            <th>교우명</th>
            <td><input type="text" v-model="memberInfo.memberHnm" disabled></td>
            <th>한자명</th>
            <td><input type="text" v-model="memberInfo.memberCnm" disabled></td>
            <th>영문명</th>
            <td><input type="text" v-model="memberInfo.memberEnm" disabled></td>
          </tr>
          <tr>
            <th>직책</th>
            <td>
              <select v-model="query.positionCd" name="position">
                <option v-for="item in positionList" :key="item.code" :label="item.codeNm" :value="item.code">
                  {{ item }}
                </option>
              </select>
            </td>
            <th>기수</th>
            <td><input type="text" v-model="query.reign"></td>
            <th>취임일</th>
            <td>
              <div class="inline-flex">
                <div class="inline-flex">
                  <input type="text" v-model="query.erectDate" v-mask="'####-##-##'">
                </div>
              </div>
            </td>
            <th>퇴임일</th>
            <td>
              <div class="inline-flex">
                <input type="text" v-model="query.expireDate" v-mask="'####-##-##'">
              </div>
            </td>
          </tr>
          <tr>
            <th>비고</th>
            <td colspan="7">
              <textarea v-model="query.remark"></textarea>
            </td>
          </tr>
        </table>
      </div>
    </template>
    <template slot="footer">
      <md-button class="md-info md-sm" @click="saveExecutive" v-if="executiveMode==1">취임</md-button>
      <md-button class="md-info md-sm" @click="saveExecutive" v-if="executiveMode==2">수정</md-button>
<!--      <md-button class="md-warning md-sm" @click="deleteExecutive" v-if="executiveMode==2">퇴임</md-button>-->
      <md-button class="md-default md-sm" @click="closed">취소</md-button>
    </template>
  </modal>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import Swal from "sweetalert2";
import moment from "moment";

import { Modal } from "@/components";

export default {
  name: "GroupExecutiveComp",
  props: {
    isShow : {
      type: Boolean,
      default: false
    },
    executiveMode : {
      type: Number,
      default: 1
    }
  },
  components: {
    Modal
  },

  created() {
    this.getPositionList();
    this.setData();
  },

  computed: {
  },
  data() {
    return {
      memberInfo : {},
      query : {
        branchId : "",
        memberNo : null,
        erectDate : null, // 취임일
        expireDate : null, // 퇴임일
        positionCd : null, // 직책
        reign : '', // 기수
        remark : '' // 메모
      },
      positionList : [],
    };
  },
  methods: {
    clearQuery () {
      this.query = {
        branchId : "",
        memberNo : null,
        erectDate : null, // 취임일
        expireDate : null, // 퇴임일
        positionCd : null, // 직책
        reign : '', // 기수
        remark : '' // 메모
      }
    },
    setData (item){
      this.clearQuery();
      this.memberInfo = item;
      this.query = {
        branchId : item.branchId,
        memberNo : item.memberNo,
        erectDate : item.erectDate && item.erectDate != '' ? moment(item.erectDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"), // 취임일
        expireDate : item.expireDate && item.expireDate != '' ? moment(item.expireDate).format("YYYY-MM-DD") : null, // 취임일
        positionCd : item.positionCd, // 직책
        reign : item.reign, // 기수
        remark : item.remark // 메모
      }
    },
    closed(){
      this.$emit('update:isShow', false);
    },
    getPositionList(){
      kuaaFnc.fncPositionCodes(null,res => {
        this.positionList = res.data.data.contents;
      });
    },
    saveExecutive(){
      if(!this.query.reign || this.query.reign == ''){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'기수를 입력 해 주세요'}));
        return;
      }
      
      if(!this.query.positionCd || this.query.positionCd == ''){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'직책를 입력 해 주세요'}));
        return;
      }
            
      let modalOptions = kuaaFnc.getSwalModaloptions();
      let params = {
        branchId : this.memberInfo.branchId,
        memberNo : this.memberInfo.memberNo,
        erectDate : this.query.erectDate && this.query.erectDate != '' ? moment(this.query.erectDate).format("YYYYMMDD") : null, // 취임일
        expireDate : this.query.expireDate && this.query.expireDate != '' ? moment(this.query.expireDate).format("YYYYMMDD") : null, // 취임일
        positionCd : this.query.positionCd, // 직책
        reign : this.query.reign, // 기수
        remark : this.query.remark // 메모
      };
      
      kuaaApi.sendServer( 
        URL_CONST.SAVE_BRANCH_ORG,
        params,
        "post",
        response => {
          if (response.data.success){
            modalOptions.html = `저장 되었습니다.`;
            Swal.fire(modalOptions);
            this.closed();
          } else {
            modalOptions.html = `저장 실패 하였습니다.`;
            Swal.fire(modalOptions);
            this.closed();
          }
          this.$emit('returnResult');
        }
      );
    },

    deleteExecutive(){
      let modalOptions = kuaaFnc.getSwalModaloptions();
      let params = {
        branchId : this.memberInfo.branchId,
        memberNo : this.memberInfo.memberNo,
        erectDate : this.query.erectDate && this.query.erectDate != '' ? moment(this.query.erectDate).format("YYYYMMDD") : null, // 취임일
        expireDate : this.query.expireDate && this.query.expireDate != '' ? moment(this.query.expireDate).format("YYYYMMDD") : null, // 취임일
      };
      kuaaApi.sendServer(
        URL_CONST.DELETE_BRANCH_ORG,
        params,
        "post",
        response => {
          if (response.data.success){
            modalOptions.html = `삭제 되었습니다.`;
            Swal.fire(modalOptions);
            this.closed();
          } else {
            modalOptions.html = `삭제 실패 하였습니다.`;
            Swal.fire(modalOptions);
            this.closed();
          }
          this.$emit('returnResult');
        }
      );
    }

  }
};
</script>

<style lang="css" scoped>
  .modal-mask {z-index: 99}
</style>